import { FC } from 'react';
import { Logo } from '../header/Logo';

export const AuthLogo: FC = () => {
  return (
    <div className="flex justify-center mb-8">
      <Logo className="h-24 w-auto" />
    </div>
  );
};
